<!--Получает хэдер и row от них строит выбранную таблицу-->
<template>
  <div>
    <v-divider id="anchor-table" />
    <v-subheader class="grey--text text--darken-3 subheading" style="font-size: 1rem; margin-left: 0; margin-top: 20px; font-weight: bold" inset>
      {{ this.tableName }}
      <v-spacer />
      <v-text-field
        v-if="this.Value.length > 5 && this.InfoForEmptyValue === false"
        v-model="search"
        label="Фильтр данных по столбцам"
        single-line
      />
      <v-btn v-if="this.InfoForEmptyValue === false" text small @click="getXlsx"> скачать excel </v-btn>
    </v-subheader>
    <div class="table-wrapper Flipped">
      <table id="main-table" class="data-table Content mt-2">
        <thead class="table-main-header subheading"
            v-html="this.Header" ref="header"
        />
        <tbody v-if="this.InfoForEmptyValue === false">
          <tr v-for="(row, indexRow) in pagination" :key="indexRow">
            <td v-for="(cell, indexCell) in row.value" :key="indexCell">
              {{ cell }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="this.InfoForEmptyValue !== false && this.InfoForEmptyValue !== ''">
      <v-alert
          border="top"
          colored-border
          type="info"
          elevation="2">
        Сведения по таблице {{this.tableName}} на территории данного муниципального образования за {{ this.year }} год отсутствуют
      </v-alert>
    </div>
    <div v-if="showPagination && this.InfoForEmptyValue === false" class="text-xs-center">
      <v-pagination v-model="page" :length="maxPage + 1" :total-visible="7" />
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import axios from "axios";
import {bus} from "@/main";

export default {
  name: "RegionTable",
  data() {
    return {
      page: 1,
      search: "",
      tableName: "",
      Header: "",
      Value: [],
      year: "",
      lvl: "",
      InfoForEmptyValue: '',
    };
  },
  computed: {
    pagination() {
      return this.filteredTableValue.slice(
          this.page === 1 ? 0 : this.page * 5 - 5,
          this.page === 1 ? 5 : this.page * 5
      );
    },
    maxPage() {
      return (this.filteredTableValue.length / 5) | 0;
    },
    showPagination() {
      return this.maxPage > 0;
    },
    filteredTableValue() {
      return this.Value.filter(row => {
        let tmpRow = false;
        row = row.value
        row.some(cell => {
          tmpRow = cell.toUpperCase().includes(this.search.toUpperCase()) || tmpRow;
        });
        return tmpRow;
      });
    },
  },
  methods: {
    getXlsx() {
      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "",
        Subject: "Эко паспорта",
        Author: "ЦРМПиООС",
        CreatedDate: Date.now()
      };
      wb.SheetNames.push("Главная страница");

      let table = [];
      let row = [];
      let header = this.$refs.header
      row.push(...this.filteredTableValue)
      row.forEach(item => {
        table.push(item.value);
      });
      if (this.lvl === 0) {
        this.lvl = 1
      }
      wb.Sheets["Главная страница"] = XLSX.utils.table_to_sheet(header);
      XLSX.utils.sheet_add_aoa(wb.Sheets["Главная страница"], table, {origin: this.lvl});
      XLSX.writeFile(wb, this.tableName + ".xlsx", {});
    },
    getHeaderTable(year, headerId, regionId) {
      this.search = ""
      axios
        .post("/eco-passport/get-header", {year, regionId, headerId})
        .then(response => {
          this.Header = response.data.text
          this.lvl = response.data.lvl
        })
        .catch(e => alert(e.toString()));
      axios
        .post("/eco-passport/get-table", {year, regionId, headerId})
        .then(responseTable => {
          if (responseTable.data !== null) {
            this.Value = responseTable.data
            this.InfoForEmptyValue = false
          } else {
            this.InfoForEmptyValue = true
          }
        })
        .catch(e => alert(e.toString()));
    },
  },
  created() {
    bus.$on('selectedTable', info => {
      this.tableName = info.tableName
      this.page = 1
      this.year = info.selectedYear
      this.getHeaderTable(info.selectedYear, info.headerID[0], info.regionId)
      setTimeout(()=> {
        const el = document.getElementById('table');
        el.scrollIntoView({ behavior: "smooth" });
      }, 100)
      bus.$emit('message', {
        show:false
      })
    });
  }
};
</script>

<style scoped>
.Flipped,
.Flipped .Content {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg); /* IE 9 */
  -webkit-transform: rotateX(180deg); /* Safari and Chrome */
}

.table-wrapper {
  overflow-x: scroll;
}

table {
  width: 100%;
  border-color: #757575;
  border-collapse: collapse;
}

tr:nth-child(even) {
  background-color: #fafafa;
}

tbody tr td {
  border: 1px solid #bdbdbd;
  text-align: center;
  color: #212121;
  padding: 8px;
}

.table-main-header >>> th {
  border: 1px solid #bdbdbd;
  text-align: center;
  background-color: #f5f5f5;
  color: #424242;
  padding: 8px;
}

tr:hover {
  background-color: #eeeeee;
}
</style>

<style module></style>
